// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

let wrapper = "relative inline-block";

let xSmallIconStyle = "absolute left-[25px] top-[21px] opacity-40";

let smallIconStyle = "absolute left-[34px] top-[29px] opacity-40";

let mediumIconStyle = "absolute left-[38px] top-[33px] opacity-40";

let largeIconStyle = "absolute left-[57px] top-[49px] opacity-40";

function TerminatedAgentIconOverlay(props) {
  let __size = props.size;
  let size = __size !== undefined ? __size : "small";
  return JsxRuntime.jsxs("span", {
    children: [
      size === "xLarge" ? JsxRuntime.jsx("span", {
          children: JsxRuntime.jsx(IconV5.make, {
            icon: "unavailable",
            size: 36,
            className: "text-tan-error-500"
          }),
          className: largeIconStyle
        }) : (
          size === "medium" ? JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "unavailable",
                size: 24,
                className: "text-tan-error-500"
              }),
              className: mediumIconStyle
            }) : (
              size === "small" ? JsxRuntime.jsx("span", {
                  children: JsxRuntime.jsx(IconV5.make, {
                    icon: "unavailable",
                    size: 20,
                    className: "text-tan-error-500"
                  }),
                  className: smallIconStyle
                }) : (
                  size === "xSmall" ? JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(IconV5.make, {
                        icon: "unavailable",
                        size: 18,
                        className: "text-tan-error-500"
                      }),
                      className: xSmallIconStyle
                    }) : JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(IconV5.make, {
                        icon: "unavailable",
                        size: 36,
                        className: "text-tan-error-500"
                      }),
                      className: largeIconStyle
                    })
                )
            )
        ),
      props.children
    ],
    className: wrapper
  });
}

let Icon;

let make = TerminatedAgentIconOverlay;

exports.wrapper = wrapper;
exports.xSmallIconStyle = xSmallIconStyle;
exports.smallIconStyle = smallIconStyle;
exports.mediumIconStyle = mediumIconStyle;
exports.largeIconStyle = largeIconStyle;
exports.Icon = Icon;
exports.make = make;
/* IconV5 Not a pure module */
